import { render, staticRenderFns } from "./FormulaPrefix.vue?vue&type=template&id=33572dd5&scoped=true&"
import script from "./FormulaPrefix.vue?vue&type=script&lang=js&"
export * from "./FormulaPrefix.vue?vue&type=script&lang=js&"
import style0 from "./FormulaPrefix.vue?vue&type=style&index=0&id=33572dd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33572dd5",
  null
  
)

export default component.exports